import clsx from 'clsx'

import Arrow from '@/atoms/Arrow/Arrow'

function Indicator(props: IndicatorProps) {
  const { currentSlide, direction, onClick } = props

  const handleClick = () => {
    if (direction === 'left') {
      onClick(currentSlide - 1)
      return
    }

    onClick(currentSlide + 1)
  }

  return (
    <button
      onClick={handleClick}
      className={clsx(
        'w-12 h-12 bg-black/50 z-20 flex justify-center text-white items-center rounded-full absolute top-1/2 -translate-y-1/2 active:bg-black/80',
        {
          'left-0': direction === 'left',
          'right-0': direction === 'right',
        }
      )}
    >
      <Arrow className="w-5" direction={direction} variant="primary" />
    </button>
  )
}

interface IndicatorProps {
  currentSlide: number
  direction: 'left' | 'right'
  onClick(index: number): void
}

export default Indicator
